import type { LucideIcon } from "lucide-react";
import type { FC, SVGProps } from "react";

export type NavIcon = LucideIcon | FC<SVGProps<SVGSVGElement>>;

const iconProps = {
  viewBox: "0 0 24 24",
  fill: "none" as const,
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": true as const,
};

const strokeProps = {
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

export const SidebarAdsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...iconProps} {...props}>
    <path
      d="M12.2902 12.8284L14.9781 20.5364C15.1101 20.9137 15.6421 20.9164 15.7768 20.5404L16.9701 17.2244C17.0128 17.1057 17.1061 17.0124 17.2248 16.9697L20.5408 15.7764C20.9168 15.6417 20.9141 15.1084 20.5368 14.9777L12.8288 12.2897C12.4942 12.1724 12.1728 12.4951 12.2888 12.8297L12.2902 12.8284Z"
      {...strokeProps}
    />
    <path d="M17.0391 17.0376L21.6684 21.6669" {...strokeProps} />
    <path
      d="M17.0744 9.53422C16.1602 7.64329 14.2432 6.33301 12.0016 6.33301C8.87229 6.33301 6.33496 8.87047 6.33496 11.9997C6.33496 14.2402 7.64416 16.1555 9.53363 17.0699"
      {...strokeProps}
    />
    <path
      d="M21.6114 11.1173C21.1645 6.19388 17.0403 2.3335 12.0007 2.3335C6.66198 2.3335 2.33398 6.66163 2.33398 12.0002C2.33398 17.0386 6.19372 21.1623 11.1159 21.6108"
      {...strokeProps}
    />
  </svg>
);

export const SidebarAssetsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...iconProps} {...props}>
    <path
      d="M16.2813 9.31145L13.22 7.46479C12.684 7.14079 12 7.52745 12 8.15279V11.8475C12 12.4741 12.684 12.8595 13.22 12.5355L16.2813 10.6888C16.8 10.3755 16.8 9.62479 16.2813 9.31145Z"
      fill="currentColor"
    />
    <path
      d="M2.33398 9V17.6667C2.33398 19.14 3.52732 20.3333 5.00065 20.3333H16.334"
      {...strokeProps}
    />
    <path
      d="M8.99935 16.3335H18.9993C20.4721 16.3335 21.666 15.1396 21.666 13.6668V6.3335C21.666 4.86074 20.4721 3.66683 18.9993 3.66683L8.99935 3.66683C7.52659 3.66683 6.33268 4.86074 6.33268 6.3335L6.33268 13.6668C6.33268 15.1396 7.52659 16.3335 8.99935 16.3335Z"
      {...strokeProps}
    />
  </svg>
);

export const SidebarChatIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...iconProps} {...props}>
    <path
      d="M20.4531 17.2406L18.4323 16.5677L17.7588 14.5469C17.6499 14.2208 17.3442 14 17 14C16.6558 14 16.35 14.2208 16.2412 14.5469L15.5677 16.5677L13.5469 17.2406C13.2203 17.35 13 17.6553 13 18C13 18.3447 13.2203 18.65 13.5469 18.7594L15.5677 19.4323L16.2412 21.4531C16.3501 21.7792 16.6558 22 17 22C17.3442 22 17.65 21.7792 17.7588 21.4531L18.4323 19.4323L20.4531 18.7594C20.7797 18.65 21 18.3447 21 18C21 17.6553 20.7797 17.35 20.4531 17.2406Z"
      fill="currentColor"
    />
    <path
      d="M19.6363 11.5682C19.6363 6.83617 15.8001 3 11.0682 3C6.33617 3 2.5 6.83617 2.5 11.5682C2.5 13.127 2.92309 14.5841 3.64991 15.8428C4.15809 16.7953 3.58727 19.0479 2.5 20.1363C3.97727 20.2167 5.92372 19.5489 6.79353 18.9864C7.37144 19.3197 8.28734 19.7617 9.48689 19.9886C9.99861 20.0855 10.5281 20.1363 11.0682 20.1363C11.0735 20.1363 11.0788 20.1363 11.0841 20.1363"
      {...strokeProps}
    />
  </svg>
);

export const SidebarExperiencesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...iconProps} {...props}>
    <path
      d="M7.66699 6.99951H9.33366C10.8065 6.99951 12.0003 8.19338 12.0003 9.66618V13.9995C12.0003 15.4723 13.1942 16.6662 14.667 16.6662H16.3337"
      {...strokeProps}
    />
    <path
      d="M5.00065 9.66732C6.47341 9.66732 7.66732 8.47341 7.66732 7.00065C7.66732 5.52789 6.47341 4.33398 5.00065 4.33398C3.52789 4.33398 2.33398 5.52789 2.33398 7.00065C2.33398 8.47341 3.52789 9.66732 5.00065 9.66732Z"
      {...strokeProps}
    />
    <path
      d="M18.9997 19.6668C20.4724 19.6668 21.6663 18.4729 21.6663 17.0002C21.6663 15.5274 20.4724 14.3335 18.9997 14.3335C17.5269 14.3335 16.333 15.5274 16.333 17.0002C16.333 18.4729 17.5269 19.6668 18.9997 19.6668Z"
      {...strokeProps}
    />
  </svg>
);

export const SidebarOpportunitiesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...iconProps} {...props}>
    <path
      d="M12 2C12.6667 4.66667 14 6.83333 16 8.5C18 10.1667 19 12 19 14C19 15.8565 18.2625 17.637 16.9497 18.9497C15.637 20.2625 13.8565 21 12 21C10.1435 21 8.36301 20.2625 7.05025 18.9497C5.7375 17.637 5 15.8565 5 14C5 12.9181 5.35089 11.8655 6 11C6 11.663 6.26339 12.2989 6.73223 12.7678C7.20107 13.2366 7.83696 13.5 8.5 13.5C9.16304 13.5 9.79893 13.2366 10.2678 12.7678C10.7366 12.2989 11 11.663 11 11C11 9 9.5 8 9.5 6C9.5 4.66667 10.3333 3.33333 12 2Z"
      {...strokeProps}
    />
  </svg>
);

export const SidebarProductsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...iconProps} {...props}>
    <path
      d="M12.1913 2.68831C11.9007 2.09898 11.1927 1.77231 10.5207 2.03098L4.52068 4.33765C4.00602 4.53498 3.66602 5.03098 3.66602 5.58165V14.391C3.66602 14.8963 3.94335 15.3096 4.33268 15.5363"
      {...strokeProps}
    />
    <path
      d="M16.1923 6.02181C15.9017 5.43248 15.1937 5.10581 14.5217 5.36448L8.52166 7.67248C8.00699 7.86981 7.66699 8.36581 7.66699 8.91648V17.7258C7.66699 18.2311 7.94433 18.6445 8.33366 18.8711"
      {...strokeProps}
    />
    <path
      d="M12.5197 11.0041L18.5197 8.69607C19.393 8.36007 20.3317 9.0054 20.3317 9.94007V18.7494C20.3317 19.3014 19.9917 19.7961 19.477 19.9934L13.477 22.3014C12.6037 22.6374 11.665 21.9921 11.665 21.0574V12.2481C11.665 11.6961 12.005 11.2014 12.5197 11.0041Z"
      fill="currentColor"
      {...strokeProps}
    />
  </svg>
);

export const SidebarSmartLinksIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...iconProps} {...props}>
    <path d="M19.001 1.6665V8.33317" {...strokeProps} />
    <path d="M22.3366 4.99951H15.6699" {...strokeProps} />
    <path
      d="M10.4914 9.85791C10.0879 10.0719 9.70912 10.349 9.36992 10.6894L9.35659 10.7027C7.51525 12.544 7.51525 15.528 9.35659 17.3694L12.2566 20.2694C14.0979 22.1107 17.0819 22.1107 18.9233 20.2694L18.9366 20.256C20.7779 18.4147 20.7779 15.4307 18.9366 13.5894L17.9201 12.5728"
      {...strokeProps}
    />
    <path
      d="M12.1768 15.4756C12.5803 15.2616 12.9591 14.9845 13.2983 14.6441L13.3116 14.6308C15.1529 12.7894 15.1529 9.80544 13.3116 7.96411L10.4116 5.06411C8.57025 3.22277 5.58625 3.22277 3.74492 5.06411L3.73159 5.07744C1.89025 6.91877 1.89025 9.90277 3.73159 11.7441L4.74813 12.7606"
      {...strokeProps}
    />
  </svg>
);

export const SidebarNavIcon = ({
  icon: Icon,
  className,
}: {
  icon: NavIcon;
  className?: string;
}) => <Icon className={className} />;
